// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2201":"52e8a12a","4247":"ab1f8cfa","9461":"ab1f8cfa"}[chunkId] + ".chunk.css";
};